import React from 'react'
import { observer } from 'mobx-react'
import { accountsAddressContainer } from 'src/models'
import { AccountProfileFormContext } from './context'
// import { B2BAccountOrgInfoForm } from './B2BAccountOrgInfoForm'
// import { B2BAccountAddressForm } from './B2BAccountAddressForm'
import { AccountFormIntlShipping } from 'src/views/components'
import { enablePhoneVerification } from 'src/utils'
import { AccountFormIntlShippingSMSVerify } from 'src/views/components/MyAccountFormIntlShipping/AccountFormIntlShippingSMSVerify'
import EventStaticAccountProfile from './EventStaticAccountProfile'
import DownConvertAccountType from './DownConvertAccountType'
import {
  getLiveEventStatus,
  getShouldEnableProfileEditInEvent,
} from 'src/utils'
import { observable } from 'mobx'

@observer
class B2BAccountProfileForm extends React.Component {
  @observable enableLiveEvent = getLiveEventStatus()
  @observable showDownConvertForm = false
  @observable enableProfileEditInEvent = getShouldEnableProfileEditInEvent()

  constructor(props) {
    super(props)
    this.showDownConvertForm = props?.history?.location?.state || false
  }

  getDefaultAddress = (prefillData = {}) => {
    const {
      name = '',
      email = '',
      typeId = '',
      size = '',
      taxNumber = '',
      phoneNumber = '',
    } = prefillData
    const addressList = accountsAddressContainer.addressData || []
    const defaultAddress =
      addressList.length > 0 &&
      addressList.find(list => list.isDefault === true)
    const dunsNumber =
      prefillData.dunsNumber || prefillData.properties?.[0]?.value || ''

    return {
      accountInfo: {
        name,
        email,
        typeId,
        size,
        dunsNumber,
        taxNumber,
        phoneNumber,
      },
      defaultAddress,
    }
  }

  getDataModal() {
    const {
      buyerAdminMailId,
      accountSettings,
      isSelfOnBoard,
      accountAttributes,
      updateAccountInfo,
      updateAccountAddress,
      updateAccountAttributeInfo,
      prefillAttributeData,
      prefillData,
      ...remainingProps
    } = this.props

    const accountPrefillData = this.getDefaultAddress(prefillData)

    return {
      constructStyle: {
        formRowClassName: 'my-2',
      },
      accountPrefillData,
      accountAttributes,
      isSelfOnBoard,
      accountSettings,
      buyerAdminMailId,
      updateAccountInfo,
      updateAccountAddress,
      updateAccountAttributeInfo,
      prefillAttributeData,
      ...remainingProps,
    }
  }

  handleShowDownConvertForm = isShow => {
    this.showDownConvertForm = isShow
  }

  render() {
    const data = this.getDataModal()
    return (
      <AccountProfileFormContext.Provider value={data}>
        {/* <B2BAccountOrgInfoForm /> */}
        {data?.isSelfOnBoard === false && data?.accountPrefillData && (
          // <B2BAccountAddressForm />
          <>
            {this.showDownConvertForm ? (
              <DownConvertAccountType
                handleShowDownConvertForm={this.handleShowDownConvertForm}
              />
            ) : enablePhoneVerification() && this.enableLiveEvent !== 'true' ? (
              <AccountFormIntlShippingSMSVerify
                handleShowDownConvertForm={this.handleShowDownConvertForm}
                history={this.props?.history || ''}
              />
            ) : this.enableLiveEvent === 'true' &&
              this.enableProfileEditInEvent === 'false' ? (
              <EventStaticAccountProfile />
            ) : (
              <AccountFormIntlShipping
                handleShowDownConvertForm={this.handleShowDownConvertForm}
                history={this.props?.history || ''}
              />
            )}
          </>
        )}
      </AccountProfileFormContext.Provider>
    )
  }
}

export { B2BAccountProfileForm }
// export default B2BAccountProfileForm
export default B2BAccountProfileForm
